import React from 'react'

import { useTheme } from '@material-ui/styles'
import { ButtonBase, Grid, makeStyles } from '@material-ui/core'

import { WhatsApp } from '@material-ui/icons'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

import { useLiterals } from '~/components/Literals'
import useViewportSizes from '~/components/useViewportSize'

import { cliqueWhats } from '~/track'
import { getWhatsAppUrl } from '~/utils'
import { createSelector } from 'reselect'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 16px',
    backgroundColor: '#F2F2F2',
    transition: 'filter .2s ease-in-out',
    '&:hover': {
      filter: 'brightness(95%)',
    },
  },
  icon: {
    width: 28,
    height: 28,
    padding: 4,
    borderRadius: 9999,
    backgroundColor: '#34AF23',
  },
}))

const selector = createSelector(
  (state) => state.app.currentStore,
  (state) => state.app.currentProduct,
  (state) => state.config,
  (currentStore, currentProduct, config) => ({ currentStore, currentProduct, config }),
)

function ButtonWhatsapp({ setOpenForm }) {
  const theme = useTheme()
  const viewport = useViewportSizes()
  const classes = useStyles()
  const { currentStore: store, currentProduct: product, config } = useSelector(selector)

  const { getLiteral } = useLiterals()
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const linkWhatAppUrl = store?.whatsapp
    ? getWhatsAppUrl(
        store?.whatsapp,
        store?.name,
        product?.name ||
          Object.values(store.stats)
            .map((i) => i.name)
            .join(),
        config?.brandName,
        !!config?.showContextViewEstablishment,
        getLiteral,
        config?.textToWhatsapp,
      )
    : ''

  return (
    <>
      {config.whatsappForm ? (
        <ButtonBase
          component="a"
          variant="body1"
          style={{
            borderRadius: store?.phoneNumber && store?.whatsapp ? (!isMobile ? '0 8px 8px 0' : '0 0 8px 8px') : 8,
          }}
          className={classes.button}
          onClick={() => setOpenForm(true)}
        >
          <Grid>
            <WhatsApp className={classes.icon} style={{ color: '#FFF' }} />
            {getLiteral('2473')}
          </Grid>
          {isMobile && <ArrowForwardIosIcon style={{ color: '#698387', fontSize: 14 }} />}
        </ButtonBase>
      ) : (
        <ButtonBase
          component="a"
          variant="body1"
          target="_blank"
          rel="noopener noreferrer"
          href={linkWhatAppUrl}
          style={{
            borderRadius: store?.phoneNumber && store?.whatsapp ? (!isMobile ? '0 8px 8px 0' : '0 0 8px 8px') : 8,
          }}
          className={classes.button}
          onClick={() => cliqueWhats(product)}
        >
          <Grid>
            <WhatsApp className={classes.icon} style={{ color: '#FFF' }} />
            {getLiteral('2473')}
          </Grid>
          {isMobile && <ArrowForwardIosIcon style={{ color: '#698387', fontSize: 14 }} />}
        </ButtonBase>
      )}
    </>
  )
}

export default ButtonWhatsapp
